import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { debounce } from 'throttle-debounce';

import { getLocations } from '../../../actions/geoSuggest';
import { ILocation } from '../../../types/location';
import { TThunkDispatch } from '../../../types/redux';

export const MIN_SEARCH_LENGTH = 3;

export interface IUseLocationSuggest {
  togglePopup(value: boolean): void;
}
export const useLocationSuggest = ({ togglePopup }: IUseLocationSuggest) => {
  const dispatch = useDispatch<TThunkDispatch>();

  const [suggest, setSuggest] = useState<ILocation[]>([]);
  const [isFetching, setIsFetching] = useState(false);

  const getLocationSuggest = useCallback(
    async (value: string) => {
      if (value.length < MIN_SEARCH_LENGTH) {
        return;
      }

      setIsFetching(true);

      const locations = await dispatch(getLocations({ request: value }));

      togglePopup(true);
      setSuggest(locations);
      setIsFetching(false);
    },
    [dispatch, togglePopup],
  );

  // oxlint-disable-next-line react/exhaustive-deps
  const getLocationSuggestDebounced = useCallback(debounce(200, getLocationSuggest), [getLocationSuggest]);

  return {
    suggest,
    getLocationSuggest: getLocationSuggestDebounced,
    isFetching,
  };
};
